import Backend from 'shared/lib/Backend';
import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";

export default (id, imageURL, origin, attrs) => async (dispatch, getState) => {
  const body = new FormData();
  body.append('image_url', imageURL);
  body.append('origin', origin);
  let url = `${window.location.pathname}/upload_item_image_by_url`;
  const response = await Backend.post(url, { body });
  if(response.result === 'success') {
    const data = { alt: `${window.location.origin}${response.src}`, src: response.src, ...attrs };
    dispatch({ type: "SECTIONS/UPDATE", payload: { id, data } });
    debouncedSaveTemplate(dispatch, getState);
  } else if(response.result === 'fail') {
    dispatch({ type: "FAIL", payload: response.messages[0] });
  }
};
